/* ============================================================
   CHARMED FEDORAS® — Homepage JS
   Scroll reveal · smooth anchor scroll
   (Dawn handles its own header/mobile nav — we only manage
    our custom homepage section behaviours)
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     SCROLL REVEAL — IntersectionObserver
  ---------------------------------------------------------- */
  var reveals = document.querySelectorAll('.charmed-reveal');

  if (reveals.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -48px 0px' }
      );

      reveals.forEach(function (el, idx) {
        // Stagger cards within a grid by their sibling index
        var siblings = el.parentElement
          ? Array.from(el.parentElement.querySelectorAll('.charmed-reveal'))
          : [];
        var pos = siblings.indexOf(el);
        if (pos > 0) el.style.transitionDelay = (pos * 0.11) + 's';
        io.observe(el);
      });
    } else {
      // Fallback: show all immediately
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ----------------------------------------------------------
     HERO — always in viewport on load, trigger immediately
  ---------------------------------------------------------- */
  var heroReveal = document.querySelector('.charmed-hero .charmed-reveal');
  if (heroReveal) {
    setTimeout(function () { heroReveal.classList.add('is-visible'); }, 120);
  }

  /* ----------------------------------------------------------
     SMOOTH SCROLL for anchor links inside our sections
  ---------------------------------------------------------- */
  document.querySelectorAll('.charmed-section a[href^="#"], .charmed-hero a[href^="#"]')
    .forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = this.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var offset = 80; // approx Dawn header height
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

})();
